import React from 'react';
import { string, number, arrayOf, shape } from 'prop-types';

import { makeParagraph } from 'utils';
import Icon from 'components/icon';

const VideoCard = ({
    badges,
    thumbnailAlt,
    estimate,
    language,
    date,
    dateTitle,
    description,
    title,
    filesCount,
    filesTitle,
    url,
    target,
    buttonTitle,
    previewImage
}) =>  (
    <article className="c-video-card">
        <div className="c-video-card__thumbnail">
            {!!previewImage && (
                <img
                    loading="lazy"
                    src={previewImage}
                    alt={thumbnailAlt || ''}
                />
            )}
            <span className="c-video-play-button" aria-hidden="true">
                <Icon glyph="play-circle" />
            </span>
            {badges && !!badges.length && (
                <div className="c-video-badges">
                    {badges.map(({ bgColor, color, id, title: badgeTitle }) => (
                        <span
                            className="c-video-badges__item"
                            key={id}
                            style={{ backgroundColor: bgColor, color: color }}
                        >
                            {badgeTitle}
                        </span>
                    ))}
                </div>
            )}
            {estimate && (
                <span className="c-video-estimate c-video-estimate--rounded">
                    {estimate}
                </span>
            )}
        </div>

        <div className="c-video-card__body">
            {(language || date) && (
                <div className="c-video-card__info">
                    <span>
                        {language && language}, {dateTitle && dateTitle}{' '}
                        {date && date}
                    </span>
                    {filesCount && (
                        <span className="c-video-card__attachment">
                            <Icon glyph="attachment" />
                            {filesCount.toString()} {filesTitle}
                        </span>
                    )}
                </div>
            )}

            {title && <h3 className="c-video-card__title">{title}</h3>}

            {description && (
                <div
                    className="c-video-card__description"
                    dangerouslySetInnerHTML={{
                        __html: makeParagraph(description)
                    }}
                />
            )}
        </div>
        {url && (
            <div className="c-video-card__footer">
                <a
                    className="c-video-card__link"
                    href={url}
                    target={target || undefined}
                >
                    <span className="link">{buttonTitle}</span>
                </a>
            </div>
        )}
    </article>
);

VideoCard.propTypes = {
    badges: arrayOf(
        shape({ bgColor: string, color: string, id: string, title: string })
    ),
    buttonTitle: string.isRequired,
    url: string.isRequired,
    target: string,
    thumbnailAlt: string,
    estimate: string.isRequired,
    language: string.isRequired,
    date: string.isRequired,
    dateTitle: string.isRequired,
    filesCount: number,
    filesTitle: string,
    description: string.isRequired,
    title: string.isRequired,
    previewImage: string.isRequired
};

export default VideoCard;
